import React from "react";

export type PersonInformationProps = {
  name: string;
  id?: number;
  email?: string;
  open_user?: boolean;
};

const PersonInformationTable: React.FC<PersonInformationProps> = ({
  id,
  open_user,
  name,
  email,
}) => {
  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (open_user) {
      window.open(`/users/${id}`, "_blank");
    }
  };
  return (
    <div className="ml-4">
      {open_user ? (
        <>
          <div
            className="font-medium text-gray-900 cursor-pointer"
            onClick={handleClick}
          >
            {name}
          </div>
          <div className="mt-1 text-gray-500">{email}</div>
        </>
      ) : email ? (
        <>
          <div className="font-medium text-gray-900 cursor-pointer">{name}</div>
          <div className="mt-1 text-gray-500">{email}</div>
        </>
      ) : (
        <div className="font-medium text-gray-900 cursor-pointer">{name}</div>
      )}
    </div>
  );
};

export default PersonInformationTable;
